import { gosNREUMOriginals } from '../../window/nreum';
export const originals = gosNREUMOriginals().o;